import apis from "../../core/apis.js";

class EventsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.marketingEvents).get(options);
  }

  get(id) {
    return this.$resource(apis.marketingEvents + id).get();
  }

  search(search = "") {
    return this.$resource(apis.marketingEvents).get({ search });
  }

  post(item) {
    return this.$resource(apis.marketingEvents).save(item);
  }
  updateAction(id, name, item) {
    return this.$resource(apis.marketingEvents + id + `/${name}`).save(item);
  }
  update(id, item) {
    return this.$resource(apis.marketingEvents + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default EventsResource;



// WEBPACK FOOTER //
// ./src/resources/events/events.resource.js